import { componentRect, resizedComponentRect } from '../core/component-size'

function cancelGesture (state) {
  if (state.gesture) state.gesture.cancel()
  state.gesture = null
  if (state.blur) window.removeEventListener('blur', state.blur)
  if (state.move && document.onmousemove === state.move) document.onmousemove = null
  if (state.up && document.onmouseup === state.up) document.onmouseup = null
  state.frame.moveActive = false
  state.frame.rangeActive = false
}

// 旧 Avue 没有画布边界参数；仅适配当前实例，不修改 CDN 或全局组件。
export default {
  inserted (element, binding, vnode) {
    const frame = vnode.componentInstance
    if (!frame || typeof frame.rangeMove !== 'function' || typeof frame.handleMove !== 'function') return
    const state = element._canvasBounds = { ...binding.value, frame, originals: {} }
    ;['handleMove', 'rangeMove'].forEach(method => {
      state.originals[method] = frame[method]
      frame[method] = function (event, direction) {
        if (state.gesture) cancelGesture(state)
        state.originals[method].call(this, event, direction)
        if (!state.enabled || this.disabled || !document.onmousemove) return
        state.gesture = method === 'handleMove' && state.beginMove ? state.beginMove(this, event) : null
        const move = document.onmousemove
        state.move = document.onmousemove = event => {
          if (!state.enabled || this.disabled || this._isDestroyed) return
          if (state.gesture) { state.gesture.move(event); return }
          move.call(document, event)
          const rect = { left: this.baseLeft, top: this.baseTop, width: this.baseWidth, height: this.baseHeight }
          const bounded = method === 'rangeMove' ? resizedComponentRect(rect, state.canvas, direction) : componentRect(rect, state.canvas)
          this.setLeft(bounded.left); this.setTop(bounded.top)
          this.baseWidth = bounded.width; this.baseHeight = bounded.height
        }
        const up = document.onmouseup
        state.up = document.onmouseup = event => {
          const gesture = state.gesture
          state.gesture = null
          if (state.blur) window.removeEventListener('blur', state.blur)
          if (gesture) gesture.finish()
          if (up) up.call(document, event)
        }
        if (state.gesture) {
          state.blur = () => cancelGesture(state)
          window.addEventListener('blur', state.blur)
        }
      }
    })
  },
  update (element, binding) {
    if (element._canvasBounds) Object.assign(element._canvasBounds, binding.value)
  },
  unbind (element) {
    const state = element._canvasBounds
    if (!state) return
    if (state.gesture) cancelGesture(state)
    Object.assign(state.frame, state.originals)
    if (state.move && document.onmousemove === state.move) {
      document.onmousemove = null
      if (document.onmouseup === state.up) document.onmouseup = null
    }
    delete element._canvasBounds
  }
}
